import React from 'react';
import { Row, Col } from 'antd';
import { rowDefaultProps } from 'src/utils/grid';
import styles from './Quote.module.scss';

export interface QuoteProps {
  quote: string;
  author_name: string;
}

const Quote: React.FunctionComponent<QuoteProps> = (props: QuoteProps) => {
  const { quote, author_name } = props;

  return (
    <div className={styles.container}>
      <Row {...rowDefaultProps}>
        <Col md={{ span: 16, offset: 4 }} sm={{ span: 24 }}>
          <blockquote className={styles.textContainer}>
            <h2>{quote}</h2>
            <cite className={styles.authorName}>{author_name}</cite>
          </blockquote>
        </Col>
      </Row>
    </div>
  );
};

export default Quote;
